<a *ngIf="title"id="{{idTooltip}}"  class="tooltip {{type}}" [attr.message]=title [ngClass]="title ? 'tooltip-message' : ''" >
  <i class="{{ icon }}"></i>
</a>
<a *ngIf="image" id="{{idTooltip}}"  class="tooltip {{type}} {{image}}">
  <i class="{{ icon }}"></i>
</a>